import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Box,
  useTheme,
  InputBase,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Stack,
  Tooltip,
  Typography,
  Divider,
  CircularProgress,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";

import Header from "../../components/Header";
import { tokens } from "../../theme";
import LoadingSpinner from "../../loadingSpinner";
import ModalCharge from "../../modal/modalCharge";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalHorario from "../../modal/horarios/modalHorarios";
import ModalGrupo from "../../modal/grupos/modalGrupos";
import ModalIntercambio from "../../modal/intercambio/modalIntercambio";

import {
  getDatosUserView,
  putDatosUser,
  getOneUsuario,
} from "../../services/user.services";
import {
  scheduleUserUpdate,
  getScheduledJobs,
  swapUserSchedules,
  logSwapEvent,
} from "../../services/scheduling.services";
import { getApiBaseUrl } from "../../utils/getApiBaseUrl";
import secureStorage from "../../utils/secureStorage";

const defaultScheduleForm = {
  executeAt: "",
  horario: "",
  grupo: "",
  nombre: "",
  apellido: "",
  cedula: "",
  salarioExterno: "",
  salarioIps: "",
  nroCuenta: "",
  adelanto: "",
  bonificacion: "",
  reason: "",
};

const DEFAULT_COMPANY = "GENERAL";

const areSelectionsEqual = (left, right) => {
  if (left.length !== right.length) {
    return false;
  }
  return left.every((value, index) => value === right[index]);
};

const Usuarioview = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [horario, setHorario] = useState("");
  const [grupo, setGrupo] = useState("");
  const [nuevoPassword, setNuevoPassword] = useState("");
  const [confirmarPassword, setConfirmarPassword] = useState("");
  const [openModalHorario, setOpenModalHorario] = useState(false);
  const [openModalGrupo, setOpenModalGrupo] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [cambiarPassword, setCambiarPassword] = useState(false);
  const [userLevel, setUserLevel] = useState(null);
  const [selectedUserIds, setSelectedUserIds] = useState([]);

  const [empresas, setEmpresas] = useState([]);
  const [empresaActiva, setEmpresaActiva] = useState(DEFAULT_COMPANY);
  const [grupoActivo, setGrupoActivo] = useState(null);
  const [horarioActivo, setHorarioActivo] = useState(null);

  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [cedula, setCedula] = useState("");
  const [adelanto, setAdelanto] = useState("");
  const [bonificacion, setBonificacion] = useState("");
  const [salarioExterno, setSalarioExterno] = useState("");
  const [salarioIps, setSalarioIps] = useState("");
  const [nroCuenta, setNroCuenta] = useState("");

  const [scheduleHorarioOpen, setScheduleHorarioOpen] = useState(false);
  const [scheduleGrupoOpen, setScheduleGrupoOpen] = useState(false);

  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [scheduleForm, setScheduleForm] = useState(defaultScheduleForm);
  const [scheduleSubmitting, setScheduleSubmitting] = useState(false);

  const [jobsDialogOpen, setJobsDialogOpen] = useState(false);
  const [jobsData, setJobsData] = useState([]);
  const [jobsPage, setJobsPage] = useState(0);
  const [jobsPageSize, setJobsPageSize] = useState(10);
  const [jobsRowCount, setJobsRowCount] = useState(0);
  const [jobsLoading, setJobsLoading] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedJobUser, setSelectedJobUser] = useState(null);
  const [jobDetailLoading, setJobDetailLoading] = useState(false);
  const [jobsUserFilter, setJobsUserFilter] = useState("");

  const [bullBoardOpen, setBullBoardOpen] = useState(false);

  const [swapConfirmOpen, setSwapConfirmOpen] = useState(false);
  const [swapLoading, setSwapLoading] = useState(false);
  const [swapStartAt, setSwapStartAt] = useState("");
  const [swapEndAt, setSwapEndAt] = useState("");
  const [swapReason, setSwapReason] = useState("");
  const [previewGenerating, setPreviewGenerating] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const apiBaseUrl = useMemo(() => getApiBaseUrl(), []);
  const logoUrl = useMemo(
    () => `${process.env.PUBLIC_URL}/assets/dracenaC.png`,
    []
  );

  const canManageSchedules = userLevel === 1;
  const canAccessSwapAndJobs = userLevel === 1 || userLevel === 2;
  const canViewBullBoard = userLevel === 1;

  const empresasOrdenadas = useMemo(() => {
    if (!empresas || empresas.length === 0) {
      return [];
    }
    const unique = Array.from(new Set(empresas));
    const otros = unique.filter((empresa) => empresa === "OTROS");
    const resto = unique.filter((empresa) => empresa !== "OTROS");
    return [...resto, ...otros];
  }, [empresas]);

  const gruposUnicos = useMemo(() => {
    if (empresaActiva === DEFAULT_COMPANY) {
      return [];
    }
    const resultado = [];
    const vistos = new Set();

    data
      .filter((usuario) => usuario.empresa === empresaActiva)
      .forEach((usuario) => {
        const clave = `${usuario.grupo}-${usuario.id_grupo}`;
        if (usuario.grupo && !vistos.has(clave)) {
          vistos.add(clave);
          resultado.push({ grupo: usuario.grupo, id_grupo: usuario.id_grupo });
        }
      });

    return resultado;
  }, [data, empresaActiva]);

  const horariosPorGrupo = useMemo(() => {
    if (!grupoActivo || empresaActiva === DEFAULT_COMPANY) {
      return [];
    }

    const usuariosGrupo = data.filter(
      (usuario) =>
        usuario.empresa === empresaActiva && usuario.grupo === grupoActivo
    );

    const idsUnicos = new Set(usuariosGrupo.map((usuario) => usuario.id_grupo));
    if (idsUnicos.size <= 1) {
      return [];
    }

    const horarios = new Set();
    usuariosGrupo.forEach((usuario) => {
      if (usuario.horario_descripcion) {
        horarios.add(usuario.horario_descripcion);
      }
    });

    return Array.from(horarios);
  }, [data, empresaActiva, grupoActivo]);

  const filteredRows = useMemo(() => {
    let resultado = [...data];

    if (empresaActiva !== DEFAULT_COMPANY) {
      resultado = resultado.filter(
        (usuario) => usuario.empresa === empresaActiva
      );
    }

    if (grupoActivo) {
      resultado = resultado.filter((usuario) => usuario.grupo === grupoActivo);
    }

    if (horarioActivo) {
      resultado = resultado.filter(
        (usuario) => usuario.horario_descripcion === horarioActivo
      );
    }

    if (searchValue.trim() !== "") {
      const value = searchValue.trim().toLowerCase();
      resultado = resultado.filter((usuario) =>
        (usuario.firstname ?? "").toLowerCase().includes(value) ||
        (usuario.lastname ?? "").toLowerCase().includes(value) ||
        (usuario.cargo ?? "").toLowerCase().includes(value) ||
        (usuario.cedula ?? "").toLowerCase().includes(value) ||
        (usuario.username ?? "").toLowerCase().includes(value)
      );
    }

    return resultado;
  }, [data, empresaActiva, grupoActivo, horarioActivo, searchValue]);

  const resetFormFields = useCallback(() => {
    setSelectedUser(null);
    setHorario("");
    setGrupo("");
    setNuevoPassword("");
    setConfirmarPassword("");
    setCambiarPassword(false);
    setShowPassword(false);
    setShowConfirmPassword(false);
    setNombre("");
    setApellido("");
    setCedula("");
    setAdelanto("");
    setBonificacion("");
    setSalarioExterno("");
    setSalarioIps("");
    setNroCuenta("");
  }, []);

  const resetInput = useCallback(() => {
    setConfirmarPassword("");
    setNuevoPassword("");
  }, []);

  const fetchUsuarios = useCallback(async () => {
    const level = secureStorage.getItem("userLevel");
    if (level) {
      const parsedLevel = Number(level);
      setUserLevel(Number.isNaN(parsedLevel) ? null : parsedLevel);
    }

    try {
      const response = await getDatosUserView();
      setData(response);

      const empresasEncontradas = [
        DEFAULT_COMPANY,
        ...new Set(
          response
            .map((usuario) => usuario.empresa)
            .filter((empresa) => empresa && empresa.trim() !== "")
        ),
      ];
      setEmpresas(empresasEncontradas);

      if (!empresasEncontradas.includes(empresaActiva)) {
        setEmpresaActiva(DEFAULT_COMPANY);
        setGrupoActivo(null);
        setHorarioActivo(null);
      }

      return response;
    } catch (fetchError) {
      console.error("Error al obtener los usuarios:", fetchError);
      toast.error("No se pudo cargar la lista de usuarios");
      return [];
    }
  }, [empresaActiva]);

  useEffect(() => {
    fetchUsuarios();
  }, [fetchUsuarios]);

  const handleClickShowPassword = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const handleClickShowConfirmPassword = useCallback(() => {
    setShowConfirmPassword((prev) => !prev);
  }, []);

  const openUserModal = useCallback((usuario) => {
    if (!usuario) {
      return;
    }

    setSelectedUser(usuario);
    setHorario(usuario.id_horarios ?? "");
    setGrupo(usuario.id_grupo ?? "");
    setNuevoPassword("");
    setConfirmarPassword("");
    setCambiarPassword(false);
    setShowPassword(false);
    setShowConfirmPassword(false);
    setNombre(usuario.firstname ? String(usuario.firstname) : "");
    setApellido(usuario.lastname ? String(usuario.lastname) : "");
    setCedula(usuario.cedula ? String(usuario.cedula) : "");
    setAdelanto(
      usuario.adelanto !== undefined && usuario.adelanto !== null
        ? String(usuario.adelanto)
        : ""
    );
    setBonificacion(
      usuario.bonificacion_familiar !== undefined &&
        usuario.bonificacion_familiar !== null
        ? String(usuario.bonificacion_familiar)
        : ""
    );
    setSalarioExterno(
      usuario.salario_externo !== undefined && usuario.salario_externo !== null
        ? String(usuario.salario_externo)
        : ""
    );
    setSalarioIps(
      usuario.salario_ips !== undefined && usuario.salario_ips !== null
        ? String(usuario.salario_ips)
        : ""
    );
    setNroCuenta(usuario.nro_cuenta ? String(usuario.nro_cuenta) : "");
    setOpenModal(true);
    setSelectedUserIds([usuario.id]);
  }, []);

  const formatCurrency = useCallback((value) => {
    if (value === null || value === undefined || value === "") {
      return "-";
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) {
      return String(value);
    }
    return numeric.toLocaleString("es-PY", {
      style: "currency",
      currency: "PYG",
      minimumFractionDigits: 0,
    });
  }, []);

  const renderCellWithTooltip = useCallback((params) => {
    const rawValue = params.value;
    const text = rawValue === null || rawValue === undefined || rawValue === ""
      ? "-"
      : String(rawValue);

    return (
      <Tooltip title={text} arrow placement="top">
        <Typography variant="body2" noWrap sx={{ width: "100%" }}>
          {text}
        </Typography>
      </Tooltip>
    );
  }, []);

  const columns = useMemo(() => {
    return [
      { field: "id", headerName: "ID", flex: 0.6 },
      { field: "id_empleado", headerName: "ID empleado", flex: 0.8 },
      {
        field: "firstname",
        headerName: "Nombre",
        flex: 1,
        cellClassName: "name-column--cell",
        renderCell: renderCellWithTooltip,
      },
      {
        field: "lastname",
        headerName: "Apellido",
        flex: 1,
        renderCell: renderCellWithTooltip,
      },
      {
        field: "cedula",
        headerName: "Cédula",
        flex: 0.9,
        renderCell: renderCellWithTooltip,
      },
      {
        field: "cargo",
        headerName: "Cargo",
        flex: 1,
        renderCell: renderCellWithTooltip,
      },
      {
        field: "empresa",
        headerName: "Empresa",
        flex: 0.9,
        renderCell: renderCellWithTooltip,
      },
      {
        field: "grupo",
        headerName: "Grupo",
        flex: 0.8,
        renderCell: renderCellWithTooltip,
      },
      {
        field: "bonificacion_familiar",
        headerName: "Bonificación",
        flex: 0.8,
        valueFormatter: (params) => formatCurrency(params.value),
        renderCell: renderCellWithTooltip,
      },
      {
        field: "adelanto",
        headerName: "Adelanto",
        flex: 0.7,
        valueFormatter: (params) => formatCurrency(params.value),
        renderCell: renderCellWithTooltip,
      },
      {
        field: "salario_ips",
        headerName: "Salario IPS",
        flex: 0.9,
        valueFormatter: (params) => formatCurrency(params.value),
        renderCell: renderCellWithTooltip,
      },
      {
        field: "salario_externo",
        headerName: "Salario interno",
        flex: 0.9,
        valueFormatter: (params) => formatCurrency(params.value),
        renderCell: renderCellWithTooltip,
      },
      {
        field: "nro_cuenta",
        headerName: "Nro. cuenta",
        flex: 0.8,
        renderCell: renderCellWithTooltip,
      },
      {
        field: "horario_descripcion",
        headerName: "Horario",
        flex: 1.1,
        renderCell: renderCellWithTooltip,
      },
      {
        field: "horario",
        headerName: "Horas",
        flex: 0.7,
        renderCell: renderCellWithTooltip,

      },
      {
        field: "acciones",
        headerName: "Acciones",
        flex: 0.6,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Button
            variant="contained"
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              openUserModal(params.row);
            }}
            sx={{
              minWidth: 0,
              padding: "4px 8px",
              backgroundColor: colors.blueAccent[700],
              "&:hover": { backgroundColor: colors.blueAccent[500] },
            }}
          >
            <EditIcon sx={{ color: "rgb(206, 220, 0)", fontSize: 22 }} />
          </Button>
        ),
      },
    ];
  }, [colors.blueAccent, formatCurrency, openUserModal, renderCellWithTooltip]);

  const handleSearchChange = useCallback((event) => {
    setSearchValue(event.target.value);
  }, []);

  const handleRowDoubleClick = useCallback(
    (params) => {
      openUserModal(params.row);
    },
    [openUserModal]
  );

  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
    resetFormFields();
  }, [resetFormFields]);

  const handleCloseModalRegistration = useCallback(() => {
    setRegistrationSuccess(false);
  }, []);

  const handleCloseModalError = useCallback(() => {
    setRegistrationError(false);
  }, []);

  const handleSelectHorario = useCallback((horarioSeleccionado) => {
    setHorario(horarioSeleccionado.id);
    setOpenModalHorario(false);
  }, []);

  const handleSelectGrupo = useCallback((grupoSeleccionado) => {
    setGrupo(grupoSeleccionado.id);
    setOpenModalGrupo(false);
  }, []);

  const handleScheduleSelectHorario = useCallback((horarioSeleccionado) => {
    setScheduleForm((prev) => ({ ...prev, horario: String(horarioSeleccionado.id) }));
    setScheduleHorarioOpen(false);
  }, []);

  const handleScheduleSelectGrupo = useCallback((grupoSeleccionado) => {
    setScheduleForm((prev) => ({ ...prev, grupo: String(grupoSeleccionado.id) }));
    setScheduleGrupoOpen(false);
  }, []);

  const handleSelectionChange = useCallback(
    (nuevoModelo) => {
      const seleccion = Array.isArray(nuevoModelo) ? nuevoModelo : [];
      const normalizados = seleccion.map((valor) => {
        const numero = Number(valor);
        return Number.isNaN(numero) ? valor : numero;
      });

      const visibleIds = new Set(
        filteredRows.map((row) => {
          const numero = Number(row.id);
          return Number.isNaN(numero) ? row.id : numero;
        })
      );

      const seleccionPersistente = selectedUserIds.filter(
        (valor) => !visibleIds.has(valor)
      );

      const combinados = [...seleccionPersistente, ...normalizados];
      const unicos = [];
      combinados.forEach((valor) => {
        if (!unicos.includes(valor)) {
          unicos.push(valor);
        }
      });

      const seleccionFinal = unicos.slice(-2);

      if (!areSelectionsEqual(seleccionFinal, selectedUserIds)) {
        setSelectedUserIds(seleccionFinal);
      }

      if (seleccionFinal.length === 1) {
        const seleccionado = data.find(
          (usuario) => usuario.id === seleccionFinal[0]
        );
        if (seleccionado) {
          setSelectedUser(seleccionado);
          setHorario(seleccionado.id_horarios ?? "");
          setGrupo(seleccionado.id_grupo ?? "");
        }
      }

      if (
        seleccionFinal.length !== 1 &&
        selectedUser &&
        !seleccionFinal.includes(selectedUser.id)
      ) {
        setSelectedUser(null);
      }
    },
    [
      data,
      filteredRows,
      selectedUser,
      selectedUserIds,
    ]
  );

  const filtrarPorEmpresa = useCallback((empresa) => {
    setEmpresaActiva(empresa);
    setGrupoActivo(null);
    setHorarioActivo(null);
  }, []);

  const handleSaveChanges = useCallback(async () => {
    if (!selectedUser) {
      toast.error("Selecciona un usuario antes de guardar");
      return;
    }

    if (!nombre.trim() || !apellido.trim() || !cedula.trim()) {
      toast.error("Los campos básicos no están completos");
      return;
    }

    if (Number(cedula) <= 0) {
      toast.error("La cédula no puede ser menor o igual a cero");
      return;
    }

    if (bonificacion !== "" && Number(bonificacion) < 0) {
      toast.error("La bonificación no puede ser negativa");
      return;
    }

    if (!horario) {
      toast.error("Debes seleccionar un horario");
      return;
    }

    if (!grupo) {
      toast.error("Debes seleccionar un grupo");
      return;
    }

    if (salarioExterno !== "" && Number(salarioExterno) < 0) {
      toast.error("El salario interno no puede ser negativo");
      return;
    }

    if (salarioIps !== "" && Number(salarioIps) < 0) {
      toast.error("El salario IPS no puede ser negativo");
      return;
    }

    if (adelanto !== "" && Number(adelanto) < 0) {
      toast.error("El adelanto no puede ser negativo");
      return;
    }

    if (cambiarPassword && nuevoPassword !== confirmarPassword) {
      toast.error("Las contraseñas no coinciden");
      return;
    }

    if (cambiarPassword && nuevoPassword.length < 5) {
      toast.error("La contraseña debe tener al menos 5 caracteres");
      return;
    }

    setIsLoading(true);

    const payload = {
      id_horarios: horario,
      id_grupo: grupo,
      firstname: nombre.trim(),
      lastname: apellido.trim(),
      cedula: cedula.trim(),
      adelanto: adelanto === "" ? 0 : Number(adelanto),
      bono_familiar: bonificacion === "" ? 0 : Number(bonificacion),
      salario_externo: salarioExterno === "" ? 0 : Number(salarioExterno),
      salario_ips: salarioIps === "" ? 0 : Number(salarioIps),
      nro_cuenta: nroCuenta,
      ...(cambiarPassword ? { Password: nuevoPassword } : {}),
    };

    try {
      await putDatosUser(selectedUser.id, payload);
      setRegistrationSuccess(true);
      resetInput();
      setOpenModal(false);
      const actualizados = await fetchUsuarios();
      if (actualizados.length > 0) {
        const actualizado = actualizados.find((usuario) => usuario.id === selectedUser.id);
        if (actualizado) {
          setSelectedUser(actualizado);
        }
      }
    } catch (saveError) {
      console.error("Error al actualizar usuario:", saveError);
      setRegistrationError(true);
      setError(saveError.message ?? "Ocurrió un error");
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 800);
    }
  }, [
    selectedUser,
    nombre,
    apellido,
    cedula,
    bonificacion,
    horario,
    grupo,
    salarioExterno,
    salarioIps,
    adelanto,
    cambiarPassword,
    nuevoPassword,
    confirmarPassword,
    resetInput,
    fetchUsuarios,
  ]);

  const resetScheduleForm = useCallback(() => {
    setScheduleForm(defaultScheduleForm);
  }, []);

  const handleScheduleFieldChange = useCallback(
    (field) => (event) => {
      const { value } = event.target;
      setScheduleForm((prev) => ({ ...prev, [field]: value }));
    },
    []
  );

  const handleOpenScheduleFromSelection = useCallback(() => {
    if (!canManageSchedules) {
      toast.error("No tienes permisos para programar actualizaciones");
      return;
    }

    if (selectedUserIds.length !== 1) {
      toast.error("Selecciona un único usuario para programar cambios");
      return;
    }

    const userId = selectedUserIds[0];
    const usuario = data.find((item) => item.id === userId);
    if (!usuario) {
      toast.error("No se encontró el usuario seleccionado");
      return;
    }

    setSelectedUser(usuario);
    setScheduleForm({
      executeAt: "",
      horario: String(usuario.id_horarios ?? ""),
      grupo: String(usuario.id_grupo ?? ""),
      nombre: usuario.firstname ? String(usuario.firstname) : "",
      apellido: usuario.lastname ? String(usuario.lastname) : "",
      cedula: usuario.cedula ? String(usuario.cedula) : "",
      salarioExterno:
        usuario.salario_externo !== undefined && usuario.salario_externo !== null
          ? String(usuario.salario_externo)
          : "",
      salarioIps:
        usuario.salario_ips !== undefined && usuario.salario_ips !== null
          ? String(usuario.salario_ips)
          : "",
      nroCuenta: usuario.nro_cuenta ? String(usuario.nro_cuenta) : "",
      adelanto:
        usuario.adelanto !== undefined && usuario.adelanto !== null
          ? String(usuario.adelanto)
          : "",
      bonificacion:
        usuario.bonificacion_familiar !== undefined &&
        usuario.bonificacion_familiar !== null
          ? String(usuario.bonificacion_familiar)
          : "",
      reason: "",
    });
    setScheduleModalOpen(true);
  }, [canManageSchedules, selectedUserIds, data]);

  const handleOpenJobsDialog = useCallback(() => {
    if (!canAccessSwapAndJobs) {
      toast.error("No tienes permisos para ver los trabajos programados");
      return;
    }
    setJobsDialogOpen(true);
  }, [canAccessSwapAndJobs]);

  const handleScheduleSubmit = useCallback(async () => {
    if (!canManageSchedules) {
      toast.error("No tienes permisos para programar cambios");
      return;
    }

    if (!selectedUser) {
      toast.error("Selecciona un usuario antes de programar cambios");
      return;
    }

    if (!scheduleForm.executeAt) {
      toast.error("Debes indicar la fecha y hora de ejecución");
      return;
    }

    const executeDate = new Date(scheduleForm.executeAt);
    if (Number.isNaN(executeDate.getTime())) {
      toast.error("La fecha programada no es válida");
      return;
    }

    if (executeDate.getTime() <= Date.now()) {
      toast.error("La ejecución debe ser en el futuro");
      return;
    }

    let parsedPatch;
    try {
      const patch = {};

      if (scheduleForm.horario !== "") {
        patch.id_horarios = Number(scheduleForm.horario);
      }
      if (scheduleForm.grupo !== "") {
        patch.id_grupo = Number(scheduleForm.grupo);
      }
      if (scheduleForm.nombre.trim() !== "") {
        patch.firstname = scheduleForm.nombre.trim();
      }
      if (scheduleForm.apellido.trim() !== "") {
        patch.lastname = scheduleForm.apellido.trim();
      }
      if (scheduleForm.cedula.trim() !== "") {
        patch.cedula = scheduleForm.cedula.trim();
      }
      if (scheduleForm.salarioExterno !== "") {
        patch.salario_externo = Number(scheduleForm.salarioExterno);
      }
      if (scheduleForm.salarioIps !== "") {
        patch.salario_ips = Number(scheduleForm.salarioIps);
      }
      if (scheduleForm.nroCuenta !== "") {
        patch.nro_cuenta = scheduleForm.nroCuenta;
      }
      if (scheduleForm.adelanto !== "") {
        patch.adelanto = Number(scheduleForm.adelanto);
      }
      if (scheduleForm.bonificacion !== "") {
        patch.bono_familiar = Number(scheduleForm.bonificacion);
      }

      if (Object.keys(patch).length === 0) {
        toast.error("No hay cambios para programar");
        return;
      }

      parsedPatch = patch;
    } catch (buildError) {
      toast.error("Error al construir el payload de actualización");
      return;
    }

    const payload = {
      executeAt: executeDate.toISOString(),
      patch: parsedPatch,
      reason: scheduleForm.reason?.trim() || undefined,
    };

    setScheduleSubmitting(true);
    try {
      await scheduleUserUpdate(selectedUser.id, payload);
      toast.success("Actualización programada correctamente");
      setScheduleModalOpen(false);
      resetScheduleForm();
      if (jobsDialogOpen) {
        fetchScheduledJobs({ page: jobsPage, pageSize: jobsPageSize });
      }
    } catch (scheduleError) {
      console.error("Error al programar la actualización:", scheduleError);
      toast.error(`No se pudo programar la actualización: ${scheduleError.message}`);
    } finally {
      setScheduleSubmitting(false);
    }
  }, [
    canManageSchedules,
    selectedUser,
    scheduleForm,
    jobsDialogOpen,
    jobsPage,
    jobsPageSize,
    resetScheduleForm,
  ]);

  const [firstSelectedUserId, secondSelectedUserId] = selectedUserIds;
  const [firstSwapUser, secondSwapUser] = useMemo(() => {
    const firstUser = data.find((usuario) => usuario.id === firstSelectedUserId) || null;
    const secondUser = data.find((usuario) => usuario.id === secondSelectedUserId) || null;
    return [firstUser, secondUser];
  }, [data, firstSelectedUserId, secondSelectedUserId]);

  const extractScheduleId = useCallback((usuario) => {
    if (!usuario) {
      return undefined;
    }
    return (
      usuario.id_horarios ??
      usuario.horario ??
      usuario.horario_id ??
      usuario.scheduleId ??
      usuario.schedule_id
    );
  }, []);

  const handleOpenSwapConfirm = useCallback(() => {
    if (!canAccessSwapAndJobs) {
      toast.error("No tienes permisos para intercambiar horarios");
      return;
    }
    if (selectedUserIds.length !== 2) {
      toast.error("Debes seleccionar exactamente dos usuarios");
      return;
    }
    setSwapStartAt("");
    setSwapEndAt("");
    setSwapReason("");
    setPreviewGenerating(false);
    setSwapConfirmOpen(true);
  }, [canAccessSwapAndJobs, selectedUserIds]);

  const handleCloseSwapConfirm = useCallback(() => {
    setSwapConfirmOpen(false);
    setSwapStartAt("");
    setSwapEndAt("");
    setSwapReason("");
    setPreviewGenerating(false);
  }, []);

  const handleSwapConfirm = useCallback(async () => {
    if (!canAccessSwapAndJobs) {
      toast.error("No tienes permisos para intercambiar horarios");
      return;
    }
    if (selectedUserIds.length !== 2) {
      toast.error("Debes seleccionar exactamente dos usuarios");
      return;
    }

    if (!swapStartAt || !swapEndAt) {
      toast.error("Debes indicar la fecha de inicio y fin");
      return;
    }

    const trimmedReason = swapReason.trim();
    if (!trimmedReason) {
      toast.error("Debes indicar el motivo del intercambio");
      return;
    }

    const startAtDate = new Date(swapStartAt);
    const endAtDate = new Date(swapEndAt);

    if (Number.isNaN(startAtDate.getTime()) || Number.isNaN(endAtDate.getTime())) {
      toast.error("Las fechas seleccionadas no son válidas");
      return;
    }

    if (startAtDate.getTime() >= endAtDate.getTime()) {
      toast.error("La fecha de fin debe ser posterior a la fecha de inicio");
      return;
    }

    const [firstUserId, secondUserId] = selectedUserIds;
    const firstUserData = data.find((usuario) => usuario.id === firstUserId);
    const secondUserData = data.find((usuario) => usuario.id === secondUserId);
    const firstSchedule = extractScheduleId(firstUserData);
    const secondSchedule = extractScheduleId(secondUserData);

    if (
      firstSchedule !== undefined &&
      secondSchedule !== undefined &&
      String(firstSchedule) === String(secondSchedule)
    ) {
      toast.error("Los usuarios seleccionados ya comparten el mismo horario");
      return;
    }

    setSwapLoading(true);
    try {
      await swapUserSchedules({
        firstUserId,
        secondUserId,
        startAt: startAtDate.toISOString(),
        endAt: endAtDate.toISOString(),
        reason: trimmedReason,
      });

      const currentUserId = secureStorage.getItem("id");
      const swapLogPayload = {
        usuarioA: String(firstUserData?.id ?? firstUserId ?? ""),
        usuarioB: String(secondUserData?.id ?? secondUserId ?? ""),
        motivo: trimmedReason,
        fechainicio: startAtDate.toISOString(),
        fechafin: endAtDate.toISOString(),
        id_usuario: currentUserId ?? "",
      };

      try {
        await logSwapEvent(swapLogPayload);
      } catch (logError) {
        console.error("No se pudo registrar el intercambio en /intercambio:", logError);
        toast.warn("El intercambio se realizó, pero no se pudo registrar el evento");
      }

      toast.success("Horarios intercambiados correctamente");
      setSwapConfirmOpen(false);
      setSelectedUserIds([]);
      setSwapStartAt("");
      setSwapEndAt("");
      setSwapReason("");
      setPreviewGenerating(false);

      const updatedList = await fetchUsuarios();

      if (selectedUser && (selectedUser.id === firstUserId || selectedUser.id === secondUserId)) {
        const refreshedUser = updatedList.find((usuario) => usuario.id === selectedUser.id);
        if (refreshedUser) {
          setSelectedUser(refreshedUser);
          setHorario(refreshedUser.id_horarios ?? "");
          setGrupo(refreshedUser.id_grupo ?? "");
        }
      }

      if (jobsDialogOpen) {
        fetchScheduledJobs({ page: jobsPage, pageSize: jobsPageSize });
      }
    } catch (swapError) {
      console.error("Error al intercambiar horarios:", swapError);
      toast.error(`No se pudo intercambiar horarios: ${swapError.message}`);
    } finally {
      setSwapLoading(false);
    }
  }, [
    canAccessSwapAndJobs,
    selectedUserIds,
    swapStartAt,
    swapEndAt,
    swapReason,
    data,
    extractScheduleId,
    fetchUsuarios,
    selectedUser,
    jobsDialogOpen,
    jobsPage,
    jobsPageSize,
  ]);

  const handlePreviewSwap = useCallback(async () => {
    if (!canAccessSwapAndJobs) {
      toast.error("No tienes permisos para intercambiar horarios");
      return;
    }
    if (previewGenerating) {
      return;
    }

    if (selectedUserIds.length !== 2) {
      toast.error("Debes seleccionar exactamente dos usuarios");
      return;
    }

    if (!swapStartAt || !swapEndAt) {
      toast.error("Debes indicar la fecha de inicio y fin");
      return;
    }

    const trimmedReason = swapReason.trim();
    if (!trimmedReason) {
      toast.error("Debes indicar el motivo del intercambio");
      return;
    }

    const startAtDate = new Date(swapStartAt);
    const endAtDate = new Date(swapEndAt);

    if (Number.isNaN(startAtDate.getTime()) || Number.isNaN(endAtDate.getTime())) {
      toast.error("Las fechas seleccionadas no son válidas");
      return;
    }

    if (startAtDate.getTime() >= endAtDate.getTime()) {
      toast.error("La fecha de fin debe ser posterior a la fecha de inicio");
      return;
    }

    const [firstUserId, secondUserId] = selectedUserIds;
    const firstUserData = data.find((usuario) => usuario.id === firstUserId);
    const secondUserData = data.find((usuario) => usuario.id === secondUserId);

    if (!firstUserData || !secondUserData) {
      toast.error("No se pudo obtener la información de los usuarios seleccionados");
      return;
    }

    const firstSchedule = extractScheduleId(firstUserData);
    const secondSchedule = extractScheduleId(secondUserData);

    if (
      firstSchedule !== undefined &&
      secondSchedule !== undefined &&
      String(firstSchedule) === String(secondSchedule)
    ) {
      toast.error("Los usuarios seleccionados ya comparten el mismo horario");
      return;
    }

    const toDataUrl = async (url) => {
      if (!url) {
        return null;
      }
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Status ${response.status}`);
        }
        const blob = await response.blob();
        return await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => reject(new Error("No se pudo leer el logo"));
          reader.readAsDataURL(blob);
        });
      } catch (imageError) {
        console.warn("No se pudo cargar el logo para el PDF", imageError);
        return null;
      }
    };

    const formatName = (usuario) => {
      if (!usuario) {
        return "-";
      }
      const partes = [usuario.firstname, usuario.lastname].filter(Boolean);
      return partes.length ? partes.join(" ") : "-";
    };

    const formattedStart = startAtDate.toLocaleDateString();
    const requestDateFormatted = new Date().toLocaleDateString();
    const sectorA = firstUserData?.grupo ?? "-";
    const cedulaA = firstUserData?.cedula ?? "-";
    const userAName = formatName(firstUserData);
    const userBName = formatName(secondUserData);

    setPreviewGenerating(true);
    try {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const marginX = 20;
      let currentY = 24;

      const logoDataUrl = await toDataUrl(logoUrl);
      if (logoDataUrl) {
        const logoWidth = 170;
        const logoHeight = 50;
        doc.addImage(
          logoDataUrl,
          "PNG",
          (pageWidth - logoWidth) / 2,
          currentY - 18,
          logoWidth,
          logoHeight
        );
        currentY += 40;
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(22);
      doc.text(
        "SOLICITUD DE CAMBIO DE TURNO",
        pageWidth / 2,
        currentY,
        { align: "center" }
      );
      currentY += 16;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      doc.text(
        `Fecha de solicitud de permiso: ${requestDateFormatted}`,
        marginX,
        currentY
      );
      currentY += 10;

      doc.text(`Funcionario: ${userAName}`, marginX, currentY);
      currentY += 10;

      doc.text(`Sector: ${sectorA}`, marginX, currentY);
      currentY += 10;

      doc.text(`C.I N°: ${cedulaA}`, marginX, currentY);
      currentY += 10;

      doc.text(`Solicito cambio de turno el día: ${formattedStart}`, marginX, currentY);
      currentY += 10;

      doc.text(`Con el funcionario/a: ${userBName}`, marginX, currentY);
      currentY += 10;

      const reasonLines = doc.splitTextToSize(
        `Motivo del cambio de turno: ${trimmedReason}`,
        pageWidth - marginX * 2
      );
      doc.text(reasonLines, marginX, currentY);
      currentY += reasonLines.length * 8 + 6;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(12);
      const commitmentText =
        "Ambos funcionarios aceptamos este cambio de turno y nos comprometemos a cumplir con nuestras responsabilidades en los turnos acordados.";
      const commitmentLines = doc.splitTextToSize(
        commitmentText,
        pageWidth - marginX * 2
      );
      doc.text(commitmentLines, pageWidth / 2, currentY, { align: "center" });
      currentY += commitmentLines.length * 8 + 12;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);
      doc.text(
        "Firma del solicitante: __________________________",
        marginX,
        currentY
      );
      currentY += 10;

      doc.text(
        "Firma del compañero/a: ________________________",
        marginX,
        currentY
      );
      currentY += 10;

      doc.text(
        "Firma del representante: _______________________ Fecha: __/__/____",
        marginX,
        currentY
      );

      const pdfUrl = doc.output("bloburl");
      window.open(pdfUrl, "_blank", "noopener,noreferrer");
    } catch (previewError) {
      console.error("Error al generar la vista previa del intercambio:", previewError);
      toast.error("No se pudo generar la vista previa en PDF");
    } finally {
      setPreviewGenerating(false);
    }
  }, [
    canAccessSwapAndJobs,
    previewGenerating,
    selectedUserIds,
    swapStartAt,
    swapEndAt,
    swapReason,
    data,
    extractScheduleId,
    logoUrl,
  ]);

  const [jobsPaginationModel, setJobsPaginationModel] = useState({
    page: jobsPage,
    pageSize: jobsPageSize,
  });

  useEffect(() => {
    setJobsPaginationModel({ page: jobsPage, pageSize: jobsPageSize });
  }, [jobsPage, jobsPageSize]);

  const fetchScheduledJobs = useCallback(
    async ({ page = jobsPage, pageSize = jobsPageSize, userId } = {}) => {
      setJobsLoading(true);
      try {
        const response = await getScheduledJobs({
          page: page + 1,
          limit: pageSize,
          userId: userId ?? (jobsUserFilter ? jobsUserFilter : undefined),
        });

        const rawJobs =
          response?.items ||
          response?.data ||
          response?.jobs ||
          response?.rows ||
          response?.results ||
          response?.scheduledJobs ||
          [];

        const total =
          response?.total ||
          response?.meta?.total ||
          response?.count ||
          response?.pagination?.total ||
          rawJobs.length;

        const normalizedJobs = rawJobs.map((job, index) => {
          const runAtValue =
            job.runAt ||
            job.executeAt ||
            job.delayUntil ||
            job.scheduledFor ||
            job.data?.executeAt ||
            job.payload?.executeAt;

          const attemptsValue =
            job.attempts ??
            job.attemptsMade ??
            job.metrics?.attempts ??
            job.retryCount ??
            job.retries ??
            0;

          const lastErrorValue =
            job.lastError ||
            job.failReason ||
            (Array.isArray(job.stacktrace) ? job.stacktrace[0] : undefined) ||
            job.errorMessage;

          const inferredUserId =
            job.userId ||
            job.data?.userId ||
            job.payload?.userId ||
            job.meta?.userId;

          const rowId =
            job.id ||
            job.jobId ||
            job._id ||
            job.key ||
            job.name ||
            `${inferredUserId ?? "job"}-${runAtValue ?? index}`;

          return {
            ...job,
            __rowId: rowId,
            runAt: runAtValue,
            attempts: attemptsValue,
            lastError: lastErrorValue,
            status:
              job.status ||
              job.state ||
              job.currentState ||
              job.progress?.state ||
              job.job?.state,
            userId: inferredUserId,
          };
        });

        setJobsData(normalizedJobs);
        setJobsRowCount(total);
      } catch (jobsError) {
        console.error("Error al obtener trabajos programados:", jobsError);
        toast.error("No se pudieron obtener los trabajos programados");
      } finally {
        setJobsLoading(false);
      }
    },
    [jobsPage, jobsPageSize, jobsUserFilter]
  );

  useEffect(() => {
    if (jobsDialogOpen) {
      fetchScheduledJobs({ page: jobsPage, pageSize: jobsPageSize });
    }
  }, [jobsDialogOpen, jobsPage, jobsPageSize, fetchScheduledJobs]);

  useEffect(() => {
    if (!jobsDialogOpen) {
      setSelectedJob(null);
      setSelectedJobUser(null);
    }
  }, [jobsDialogOpen]);

  const handleJobsPaginationChange = useCallback((model) => {
    setJobsPage(model.page);
    setJobsPageSize(model.pageSize);
  }, []);

  const handleJobsUserFilterChange = useCallback((event) => {
    setJobsUserFilter(event.target.value);
  }, []);

  const handleApplyJobsFilter = useCallback(() => {
    setJobsPage(0);
    fetchScheduledJobs({ page: 0, pageSize: jobsPageSize, userId: jobsUserFilter || undefined });
  }, [fetchScheduledJobs, jobsPageSize, jobsUserFilter]);

  const handleClearJobsFilter = useCallback(() => {
    setJobsUserFilter("");
    setJobsPage(0);
    fetchScheduledJobs({ page: 0, pageSize: jobsPageSize, userId: undefined });
  }, [fetchScheduledJobs, jobsPageSize]);

  const handleJobSelection = useCallback(async (job) => {
    setSelectedJob(job);

    if (!job?.userId) {
      setSelectedJobUser(null);
      return;
    }

    setJobDetailLoading(true);
    try {
      const userDetail = await getOneUsuario(job.userId);
      setSelectedJobUser(userDetail);
    } catch (detailError) {
      console.error("Error al obtener el detalle del usuario:", detailError);
      toast.error(`No se pudo obtener la información del usuario ${job.userId}`);
      setSelectedJobUser(null);
    } finally {
      setJobDetailLoading(false);
    }
  }, []);

  const jobColumns = useMemo(
    () => [
      {
        field: "__rowId",
        headerName: "ID",
        flex: 0.8,
        valueGetter: (params) => params.row.jobId || params.row.id || params.row.__rowId,
      },
      {
        field: "userId",
        headerName: "Usuario",
        flex: 0.7,
        valueGetter: (params) => params.row.userId ?? params.row.data?.userId ?? "-",
      },
      {
        field: "runAt",
        headerName: "Programado",
        flex: 1,
        valueGetter: (params) => {
          const value = params.row.runAt;
          if (!value) {
            return "-";
          }
          const parsed = new Date(value);
          return Number.isNaN(parsed.getTime()) ? value : parsed.toLocaleString();
        },
      },
      {
        field: "status",
        headerName: "Estado",
        flex: 0.7,
        valueGetter: (params) => params.row.status ?? "-",
      },
      {
        field: "attempts",
        headerName: "Intentos",
        flex: 0.4,
        type: "number",
        valueGetter: (params) => params.row.attempts ?? 0,
      },
      {
        field: "lastError",
        headerName: "Último error",
        flex: 1.4,
        renderCell: renderCellWithTooltip,
      },
    ],
    [renderCellWithTooltip]
  );

  const formatDateTime = useCallback((value) => {
    if (!value) {
      return "-";
    }
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? value : parsed.toLocaleString();
  }, []);

  const bullBoardUrl = useMemo(() => {
    const token = secureStorage.getItem("authToken");
    const normalizedBase = apiBaseUrl.endsWith("/") ? apiBaseUrl : `${apiBaseUrl}/`;
    if (token) {
      return `${normalizedBase}admin/queues?token=${encodeURIComponent(token)}`;
    }
    return `${normalizedBase}admin/queues`;
  }, [apiBaseUrl]);

  const handleOpenBullBoard = useCallback(() => {
    if (!canViewBullBoard) {
      toast.error("No tienes permisos para ver Bull Board");
      return;
    }
    setBullBoardOpen(true);
  }, [canViewBullBoard]);

  const handleCloseBullBoard = useCallback(() => {
    setBullBoardOpen(false);
  }, []);

  useEffect(() => {
    if (!canManageSchedules && scheduleModalOpen) {
      setScheduleModalOpen(false);
    }
  }, [canManageSchedules, scheduleModalOpen]);

  useEffect(() => {
    if (!canAccessSwapAndJobs && swapConfirmOpen) {
      setSwapConfirmOpen(false);
    }
  }, [canAccessSwapAndJobs, swapConfirmOpen]);

  useEffect(() => {
    if (!canAccessSwapAndJobs && jobsDialogOpen) {
      setJobsDialogOpen(false);
    }
  }, [canAccessSwapAndJobs, jobsDialogOpen]);

  useEffect(() => {
    if (!canViewBullBoard && bullBoardOpen) {
      setBullBoardOpen(false);
    }
  }, [canViewBullBoard, bullBoardOpen]);

  return (
    <Box m="20px">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
      >
        <Header
          title="Usuarios"
          subtitle="Gestión de usuarios y programación de cambios"
        />
        <Stack direction="row" spacing={1} alignItems="center">
          {canManageSchedules && (
            <Button
              variant="contained"
              startIcon={<EventAvailableIcon />}
              onClick={handleOpenScheduleFromSelection}
              sx={{
                backgroundColor: "rgb(206, 220, 0)",
                color: "black",
                "&:hover": { backgroundColor: "#5b6101" },
              }}
            >
              Programar cambio
            </Button>
          )}
          {canAccessSwapAndJobs && (
            <Button
              variant="outlined"
              startIcon={<SyncAltIcon />}
              onClick={handleOpenSwapConfirm}
              sx={{
                borderColor: colors.blueAccent[300],
                color: colors.grey[100],
              }}
            >
              Intercambiar horarios
            </Button>
          )}
          {canAccessSwapAndJobs && (
            <Button
              variant="outlined"
              startIcon={<ListAltIcon />}
              onClick={handleOpenJobsDialog}
              sx={{ borderColor: colors.blueAccent[300], color: colors.grey[100] }}
            >
              Trabajos programados
            </Button>
          )}
          {canViewBullBoard && (
            <Button
              variant="outlined"
              startIcon={<AssessmentIcon />}
              onClick={handleOpenBullBoard}
              sx={{ borderColor: colors.blueAccent[300], color: colors.grey[100] }}
            >
              Bull Board
            </Button>
          )}
        </Stack>
      </Box>

      <Box display="flex" alignItems="center" mt={3}>
        <Box
          display="flex"
          alignItems="center"
          backgroundColor={colors.primary[400]}
          borderRadius="3px"
          width="320px"
        >
          <InputBase
            sx={{ ml: 2, flex: 1 }}
            placeholder="Buscar"
            value={searchValue}
            onChange={handleSearchChange}
          />
          <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>

      <Box m="32px 0 0 0" height="75vh">
        <Box display="flex" gap={2} flexWrap="wrap" mb={2}>
          {empresaActiva === DEFAULT_COMPANY && (
            <Box display="flex" gap={2} flexWrap="wrap">
              {empresasOrdenadas.map((empresa) => (
                <Button
                  key={empresa}
                  variant="outlined"
                  onClick={() => filtrarPorEmpresa(empresa)}
                  sx={{
                    borderRadius: "10px",
                    padding: "10px 25px",
                    fontSize: "1rem",
                    backgroundColor:
                      empresaActiva === empresa ? "rgb(206, 220, 0)" : "transparent",
                    color: empresaActiva === empresa ? "black" : colors.grey[100],
                    "&:hover": {
                      backgroundColor: "rgb(206, 220, 0)",
                      color: "black",
                    },
                  }}
                >
                  {empresa}
                </Button>
              ))}
            </Box>
          )}

          {empresaActiva !== DEFAULT_COMPANY && !grupoActivo && (
            <Box display="flex" gap={2} flexWrap="wrap">
              {gruposUnicos.map((grupoItem) => (
                <Button
                  key={grupoItem.grupo}
                  variant="outlined"
                  onClick={() => {
                    setGrupoActivo(grupoItem.grupo);
                    setHorarioActivo(null);
                  }}
                  sx={{
                    borderRadius: "10px",
                    padding: "10px 25px",
                    fontSize: "1rem",
                    backgroundColor:
                      grupoActivo === grupoItem.grupo
                        ? "rgb(206, 220, 0)"
                        : "transparent",
                    color:
                      grupoActivo === grupoItem.grupo ? "black" : colors.grey[100],
                    "&:hover": {
                      backgroundColor: "rgb(206, 220, 0)",
                      color: "black",
                    },
                  }}
                >
                  {grupoItem.grupo}
                </Button>
              ))}
            </Box>
          )}

          {grupoActivo && horariosPorGrupo.length > 0 && (
            <Box display="flex" gap={2} flexWrap="wrap">
              {horariosPorGrupo.map((horarioDescripcion) => (
                <Button
                  key={horarioDescripcion}
                  variant="outlined"
                  onClick={() => setHorarioActivo(horarioDescripcion)}
                  sx={{
                    borderRadius: "10px",
                    padding: "10px 25px",
                    fontSize: "1rem",
                    backgroundColor:
                      horarioActivo === horarioDescripcion
                        ? "rgb(206, 220, 0)"
                        : "transparent",
                    color:
                      horarioActivo === horarioDescripcion
                        ? "black"
                        : colors.grey[100],
                    "&:hover": {
                      backgroundColor: "rgb(206, 220, 0)",
                      color: "black",
                    },
                  }}
                >
                  {horarioDescripcion}
                </Button>
              ))}
            </Box>
          )}

          {empresaActiva !== DEFAULT_COMPANY && (
            <Box>
              <Button
                onClick={() => {
                  setEmpresaActiva(DEFAULT_COMPANY);
                  setGrupoActivo(null);
                  setHorarioActivo(null);
                }}
                sx={{
                  borderRadius: "50%",
                  minWidth: "40px",
                  height: "40px",
                  fontSize: "1.2rem",
                  backgroundColor: "#c1292e",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#a61f25",
                  },
                }}
              >
                ✕
              </Button>
            </Box>
          )}
        </Box>

        <DataGrid
          rows={filteredRows}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          checkboxSelection
          selectionModel={selectedUserIds}
          onSelectionModelChange={handleSelectionChange}
          getRowId={(row) => row.id}
          onRowDoubleClick={handleRowDoubleClick}
          sx={{
            "& .MuiDataGrid-cell.name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[900],
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[900],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
              color: `${colors.grey[100]} !important`,
            },
          }}
        />
      </Box>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        sx={{
          "& .MuiDialog-paper": {
            width: "40%",
            maxWidth: "620px",
            height: "70vh",
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle
          backgroundColor={colors.primary[400]}
          fontSize={26}
          padding={4}
        >
          Editar usuario
        </DialogTitle>
        <DialogContent
          sx={{
            backgroundColor: colors.primary[400],
            padding: "20px",
          }}
        >
          {selectedUser && (
            <Box display="flex" flexDirection="column" gap={2}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="body1">
                  <strong>ID:</strong> {selectedUser.id}
                </Typography>
                <Typography variant="body1">
                  <strong>Usuario:</strong> {selectedUser.firstname} {selectedUser.lastname}
                </Typography>
              </Stack>
              <TextField
                label="Horario"
                value={horario}
                onChange={(event) => setHorario(event.target.value)}
                onClick={() => setOpenModalHorario(true)}
                fullWidth
                sx={{ marginTop: 1 }}
                InputProps={{ readOnly: true }}
              />
              <TextField
                label="Grupo"
                value={grupo}
                onChange={(event) => setGrupo(event.target.value)}
                onClick={() => setOpenModalGrupo(true)}
                fullWidth
                sx={{ marginTop: 1 }}
                InputProps={{ readOnly: true }}
              />
              <TextField
                label="Nombre"
                value={nombre}
                onChange={(event) => setNombre(event.target.value)}
                fullWidth
              />
              <TextField
                label="Apellido"
                value={apellido}
                onChange={(event) => setApellido(event.target.value)}
                fullWidth
              />
              <TextField
                label="Cédula"
                value={cedula}
                onChange={(event) => setCedula(event.target.value)}
                fullWidth
                inputProps={{ min: 1 }}
              />
              <TextField
                label="Salario interno"
                type="number"
                value={salarioExterno}
                onChange={(event) => setSalarioExterno(event.target.value)}
                fullWidth
                inputProps={{ min: 0 }}
              />
              <TextField
                label="Salario IPS"
                type="number"
                value={salarioIps}
                onChange={(event) => setSalarioIps(event.target.value)}
                fullWidth
                inputProps={{ min: 0 }}
              />
              <TextField
                label="Nro. de cuenta"
                value={nroCuenta}
                onChange={(event) => setNroCuenta(event.target.value)}
                fullWidth
              />
              <TextField
                label="Adelanto"
                type="number"
                value={adelanto}
                onChange={(event) => setAdelanto(event.target.value)}
                fullWidth
              />
              <TextField
                label="Bonificación familiar"
                type="number"
                value={bonificacion}
                onChange={(event) => setBonificacion(event.target.value)}
                fullWidth
                inputProps={{ min: 0 }}
              />
              {userLevel === 1 && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={cambiarPassword}
                      onChange={() => setCambiarPassword((prev) => !prev)}
                      sx={{
                        "& .MuiSwitch-thumb": {
                          backgroundColor: "primary",
                        },
                        "& .Mui-checked .MuiSwitch-thumb": {
                          backgroundColor: "rgb(206, 220, 0)",
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: "rgb(206, 220, 0)",
                        },
                        "& .Mui-checked .MuiSwitch-track": {
                          backgroundColor: "rgb(206, 220, 0)",
                        },
                      }}
                    />
                  }
                  label="Cambiar contraseña"
                  sx={{ marginTop: "10px" }}
                />
              )}
              {cambiarPassword && (
                <>
                  <TextField
                    label="Nueva contraseña"
                    type={showPassword ? "text" : "password"}
                    value={nuevoPassword}
                    onChange={(event) => setNuevoPassword(event.target.value)}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <IconButton onClick={handleClickShowPassword} edge="end">
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      ),
                    }}
                  />
                  <TextField
                    label="Confirmar contraseña"
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmarPassword}
                    onChange={(event) => setConfirmarPassword(event.target.value)}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <IconButton
                          onClick={handleClickShowConfirmPassword}
                          edge="end"
                        >
                          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      ),
                    }}
                  />
                </>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            backgroundColor: colors.primary[400],
            padding: 2,
          }}
        >
          <Button
            onClick={handleCloseModal}
            sx={{
              backgroundColor: "red",
              border: "none",
              color: "#ffffff",
              height: "5vh",
              width: "8vw",
              borderRadius: "20px",
              cursor: "pointer",
              "&:hover": { backgroundColor: "#910707" },
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSaveChanges}
            sx={{
              backgroundColor: "rgb(206, 220, 0)",
              border: "none",
              color: "black",
              height: "5vh",
              width: "8vw",
              borderRadius: "20px",
              cursor: "pointer",
              "&:hover": { backgroundColor: "#5b6101" },
            }}
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={scheduleModalOpen}
        onClose={() => setScheduleModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Programar actualización</DialogTitle>
        <DialogContent
          dividers
          sx={{
            backgroundColor: colors.primary[500],
            maxHeight: "65vh",
            overflowY: "auto",
          }}
        >
          {selectedUser ? (
            <Stack spacing={2}>
              <Typography variant="subtitle1">
                Usuario seleccionado: {selectedUser.firstname} {selectedUser.lastname} (ID {selectedUser.id})
              </Typography>
              <TextField
                label="Fecha y hora de ejecución"
                type="datetime-local"
                value={scheduleForm.executeAt}
                onChange={handleScheduleFieldChange("executeAt")}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
              <TextField
                label="Horario"
                value={scheduleForm.horario}
                onClick={() => setScheduleHorarioOpen(true)}
                InputProps={{ readOnly: true }}
                helperText="Haz clic para seleccionar un horario"
                fullWidth
              />
              <TextField
                label="Grupo"
                value={scheduleForm.grupo}
                onClick={() => setScheduleGrupoOpen(true)}
                InputProps={{ readOnly: true }}
                helperText="Haz clic para seleccionar un grupo"
                fullWidth
              />
              <TextField
                label="Nombre"
                value={scheduleForm.nombre}
                onChange={handleScheduleFieldChange("nombre")}
                fullWidth
              />
              <TextField
                label="Apellido"
                value={scheduleForm.apellido}
                onChange={handleScheduleFieldChange("apellido")}
                fullWidth
              />
              <TextField
                label="Cédula"
                value={scheduleForm.cedula}
                onChange={handleScheduleFieldChange("cedula")}
                fullWidth
              />
              <TextField
                label="Salario interno"
                type="number"
                value={scheduleForm.salarioExterno}
                onChange={handleScheduleFieldChange("salarioExterno")}
                fullWidth
                inputProps={{ min: 0 }}
              />
              <TextField
                label="Salario IPS"
                type="number"
                value={scheduleForm.salarioIps}
                onChange={handleScheduleFieldChange("salarioIps")}
                fullWidth
                inputProps={{ min: 0 }}
              />
              <TextField
                label="Nro. de cuenta"
                value={scheduleForm.nroCuenta}
                onChange={handleScheduleFieldChange("nroCuenta")}
                fullWidth
              />
              <TextField
                label="Adelanto"
                type="number"
                value={scheduleForm.adelanto}
                onChange={handleScheduleFieldChange("adelanto")}
                fullWidth
                inputProps={{ min: 0 }}
              />
              <TextField
                label="Bonificación familiar"
                type="number"
                value={scheduleForm.bonificacion}
                onChange={handleScheduleFieldChange("bonificacion")}
                fullWidth
                inputProps={{ min: 0 }}
              />
              <TextField
                label="Motivo (opcional)"
                value={scheduleForm.reason}
                onChange={handleScheduleFieldChange("reason")}
                fullWidth
              />
            </Stack>
          ) : (
            <Typography variant="body2">
              Selecciona un usuario para programar una actualización.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setScheduleModalOpen(false)}
            sx={{
              backgroundColor: "red",
              border: "none",
              color: "#ffffff",
              height: "3vh",
              width: "4vw",
              cursor: "pointer",
              "&:hover": { backgroundColor: "#910707" },
            }}>Cancelar</Button>
          <Button 
            onClick={handleScheduleSubmit} 
            disabled={scheduleSubmitting}
            sx={{
                backgroundColor: "rgb(206, 220, 0)",
                color: "black",
                height: "3vh",
                width: "4vw",
                "&:hover": { backgroundColor: "#5b6101" },
              }}>
            
            {scheduleSubmitting ? <CircularProgress size={18} /> : "Programar"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={jobsDialogOpen}
        onClose={() => setJobsDialogOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Trabajos programados</DialogTitle>
        <DialogContent dividers sx={{ backgroundColor: colors.primary[400] }}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2} alignItems="center">
              <TextField
                label="Filtrar por ID de usuario"
                value={jobsUserFilter}
                onChange={handleJobsUserFilterChange}
                size="small"
              />
              <Button variant="contained" onClick={handleApplyJobsFilter}>
                Aplicar filtro
              </Button>
              <Button variant="outlined" onClick={handleClearJobsFilter}>
                Limpiar filtro
              </Button>
            </Stack>
            <Box display="flex" gap={2} flexWrap="wrap">
              <Box flex={1} minWidth={360} height={360}>
                <DataGrid
                  rows={jobsData}
                  columns={jobColumns}
                  getRowId={(row) => row.__rowId}
                  onRowClick={(params) => handleJobSelection(params.row)}
                  paginationMode="server"
                  rowCount={jobsRowCount}
                  paginationModel={jobsPaginationModel}
                  onPaginationModelChange={handleJobsPaginationChange}
                  loading={jobsLoading}
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: colors.blueAccent[900],
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: colors.primary[500],
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "none",
                      backgroundColor: colors.blueAccent[900],
                    },
                  }}
                />
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box flex={1} minWidth={320}>
                <Typography variant="h6" gutterBottom>
                  Detalle del trabajo
                </Typography>
                {selectedJob ? (
                  <Stack spacing={1.5}>
                    <Typography variant="body2">
                      <strong>ID:</strong> {selectedJob.__rowId}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Usuario:</strong> {selectedJob.userId ?? "-"}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Programado:</strong> {formatDateTime(selectedJob.runAt)}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Estado:</strong> {selectedJob.status ?? "-"}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Intentos:</strong> {selectedJob.attempts ?? 0}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Último error:</strong> {selectedJob.lastError ?? "-"}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Payload:</strong>
                    </Typography>
                    <Paper variant="outlined" sx={{ p: 1, maxHeight: 160, overflow: "auto" }}>
                      <Typography
                        variant="caption"
                        component="pre"
                        sx={{ whiteSpace: "pre-wrap" }}
                      >
                        {JSON.stringify(selectedJob.data ?? selectedJob.payload ?? {}, null, 2)}
                      </Typography>
                    </Paper>
                    <Divider />
                    <Typography variant="h6">Usuario objetivo</Typography>
                    {jobDetailLoading ? (
                      <CircularProgress size={24} />
                    ) : selectedJobUser ? (
                      <Stack spacing={1}>
                        <Typography variant="body2">
                          <strong>Nombre:</strong> {selectedJobUser.firstname} {selectedJobUser.lastname}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Cédula:</strong> {selectedJobUser.cedula ?? "-"}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Horario:</strong> {selectedJobUser.horario_descripcion ?? "-"}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Grupo:</strong> {selectedJobUser.grupo ?? "-"}
                        </Typography>
                      </Stack>
                    ) : (
                      <Typography variant="body2">
                        Selecciona un trabajo para ver los detalles.
                      </Typography>
                    )}
                  </Stack>
                ) : (
                  <Typography variant="body2">
                    Selecciona un trabajo para ver los detalles.
                  </Typography>
                )}
              </Box>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => fetchScheduledJobs({ page: jobsPage, pageSize: jobsPageSize })}>
            Actualizar
          </Button>
          <Button onClick={() => setJobsDialogOpen(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={bullBoardOpen} onClose={handleCloseBullBoard} maxWidth="lg" fullWidth>
        <DialogTitle>Cola de trabajos (Bull Board)</DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <Box height="70vh">
            <iframe
              src={bullBoardUrl}
              title="Bull Board"
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => window.open(bullBoardUrl, "_blank", "noopener,noreferrer")}
            startIcon={<AssessmentIcon />}
          >
            Abrir en nueva pestaña
          </Button>
          <Button onClick={handleCloseBullBoard}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      <ModalIntercambio
        open={swapConfirmOpen}
        onClose={handleCloseSwapConfirm}
        onConfirm={handleSwapConfirm}
        onPreview={handlePreviewSwap}
        firstUser={firstSwapUser}
        secondUser={secondSwapUser}
        firstUserId={firstSelectedUserId}
        secondUserId={secondSelectedUserId}
        swapStartAt={swapStartAt}
        swapEndAt={swapEndAt}
        swapReason={swapReason}
        onChangeStartAt={setSwapStartAt}
        onChangeEndAt={setSwapEndAt}
        onChangeReason={setSwapReason}
        swapLoading={swapLoading}
        previewGenerating={previewGenerating}
      />

      <ModalHorario
        open={openModalHorario}
        onClose={() => setOpenModalHorario(false)}
        onSelectHorario={handleSelectHorario}
      />
      <ModalGrupo
        open={openModalGrupo}
        onClose={() => setOpenModalGrupo(false)}
        onSelectGrupo={handleSelectGrupo}
      />
      <ModalHorario
        open={scheduleHorarioOpen}
        onClose={() => setScheduleHorarioOpen(false)}
        onSelectHorario={handleScheduleSelectHorario}
      />
      <ModalGrupo
        open={scheduleGrupoOpen}
        onClose={() => setScheduleGrupoOpen(false)}
        onSelectGrupo={handleScheduleSelectGrupo}
      />
      <ModalCharge isLoading={isLoading} />
      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModalRegistration} />
      )}
      {registrationError && (
        <ModalError open={registrationError} onClose={handleCloseModalError} error={error} />
      )}
    </Box>
  );
};

export default Usuarioview;
